import React from "react";
import { Sparkles } from "lucide-react";
import { extracurriculars } from "../mock";

export default function Extracurriculars() {
  return (
    <div className="page" style={{ paddingTop: 96 }}>
      <div
        style={{
          padding: "0 clamp(2.2rem, 6vw, 8rem)",
          maxWidth: 1100,
          margin: "0 auto",
        }}
      >
        <div className="contact-label-luxe" style={{ marginBottom: 12 }}>
          <Sparkles size={14} />
          <span>EXTRACURRICULARS</span>
        </div>

        <h1
          className="contact-title-luxe"
          style={{ margin: 0, fontSize: "clamp(2.2rem, 4.2vw, 3.2rem)" }}
        >
          Extracurriculars &{" "}
          <span className="contact-title-gradient">Leadership</span>
        </h1>

        <p style={{ marginTop: 14, color: "rgba(255,255,255,0.78)", lineHeight: 1.8, maxWidth: "72ch" }}>
          Roles that reflect how I lead teams, show up consistently, and contribute to sustainability-focused work.
        </p>

        <div
          style={{
            marginTop: 26,
            display: "grid",
            gridTemplateColumns: "repeat(12, 1fr)",
            gap: 18,
          }}
        >
          {extracurriculars.items.map((x) => (
            <article
              key={x.title}
              className="pillars-scrollpin__content"
              style={{ gridColumn: "span 12", padding: 24 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 14,
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  {x.period ? (
                    <div
                      style={{
                        fontSize: 11,
                        letterSpacing: ".28em",
                        textTransform: "uppercase",
                        color: "rgba(255,182,217,0.8)",
                      }}
                    >
                      {x.period}
                    </div>
                  ) : null}

                  <h2
                    style={{
                      margin: x.period ? "10px 0 0" : 0,
                      fontFamily: "Playfair Display, Georgia, serif",
                      fontSize: 26,
                      lineHeight: 1.15,
                    }}
                  >
                    {x.title}
                  </h2>

                  <div style={{ marginTop: 10, color: "rgba(255,255,255,0.78)", lineHeight: 1.7 }}>
                    {x.organization}
                    {x.location ? ` • ${x.location}` : ""}
                  </div>
                </div>

                {x.ctaUrl ? (
                  <a
                    className="luxe-nav__link"
                    href={x.ctaUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {x.ctaLabel || "View"}
                  </a>
                ) : null}
              </div>

              <div style={{ marginTop: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
                {(x.meta ?? []).map((m) => (
                  <span key={m} className="pillars-scrollpin__output">
                    {m}
                  </span>
                ))}
              </div>

              <ul style={{ marginTop: 14, color: "rgba(255,255,255,0.78)", lineHeight: 1.8 }}>
                {x.bullets.map((b) => (
                  <li key={b} style={{ marginTop: 6 }}>
                    {b}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div style={{ height: 80 }} />
      </div>
    </div>
  );
}

